export const selectRecruiters = (state) => state.recruiters.recruiters;

export const selectRecruitingOffices = (state) => state.recruiters.recruitingOffices;
